import { toast } from "react-toastify";
import { CANDIDATE_CLOSURE } from "../config/apiEndPoint";
import { GET, POST, DEL } from "config/api.config";

export const getModifyClosureMetadata = async () => {
  try {
    const response = await GET(CANDIDATE_CLOSURE.GET_METADATA);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitModifyClosureFilterData = async (data = {}) => {
  try {
    const response = await POST(CANDIDATE_CLOSURE.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const deleteCandidateClosure = async (id = "") => {
  const raw = String(id ?? "").trim();
  if (!raw) {
    toast.error("Record ID is required");
    return;
  }
  try {
    const response = await DEL(CANDIDATE_CLOSURE.DELETE(raw));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
